import { Component } from '@angular/core';
import { StandaloneBaseComponent } from '../base/standalone-base.component';

@Component({
    selector: 'app-offline-base',
    templateUrl: './offline-base.component.html',
    standalone: false
})
export class OfflineBaseComponent extends StandaloneBaseComponent {
  public constructor() {
    super();
    let title = $localize`:@@OfflineTitle:Offline`;
    this.titleSet(title);
    this.metaDescriptionSet([{ key: "page", value: title }]);
  }
}
